var moduleMap = {
	"./constants": () => {
		return __webpack_require__.e(4218).then(() => (() => ((__webpack_require__(54218)))));
	},
	"./types": () => {
		return __webpack_require__.e(9776).then(() => (() => ((__webpack_require__(89776)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(8454), __webpack_require__.e(8520), __webpack_require__.e(7830), __webpack_require__.e(3557)]).then(() => (() => ((__webpack_require__(63557)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(5011), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(4582), __webpack_require__.e(8454), __webpack_require__.e(8060), __webpack_require__.e(5579), __webpack_require__.e(8520), __webpack_require__.e(482), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(5999), __webpack_require__.e(280), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(7830), __webpack_require__.e(5061)]).then(() => (() => ((__webpack_require__(85061)))));
	},
	"./Bootstrap": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(5774), __webpack_require__.e(41), __webpack_require__.e(5532), __webpack_require__.e(1008), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(4582), __webpack_require__.e(8454), __webpack_require__.e(8060), __webpack_require__.e(5579), __webpack_require__.e(8520), __webpack_require__.e(482), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(5999), __webpack_require__.e(8845), __webpack_require__.e(9358), __webpack_require__.e(7558)]).then(() => (() => ((__webpack_require__(93547)))));
	},
	"./router": () => {
		return Promise.all([__webpack_require__.e(5579), __webpack_require__.e(3688)]).then(() => (() => ((__webpack_require__(53688)))));
	},
	"./History": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8173), __webpack_require__.e(9671)]).then(() => (() => ((__webpack_require__(59671)))));
	},
	"./Authorize": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(8173), __webpack_require__.e(8454), __webpack_require__.e(8520), __webpack_require__.e(2360)]).then(() => (() => ((__webpack_require__(22360)))));
	},
	"./isAuthorized": () => {
		return Promise.all([__webpack_require__.e(8173), __webpack_require__.e(394)]).then(() => (() => ((__webpack_require__(60394)))));
	},
	"./UnAuthorized": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(7055)]).then(() => (() => ((__webpack_require__(37055)))));
	},
	"./LandingPage": () => {
		return Promise.all([__webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(482), __webpack_require__.e(7133)]).then(() => (() => ((__webpack_require__(7133)))));
	},
	"./GameSelectorUtils": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8173), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(6093)]).then(() => (() => ((__webpack_require__(66093)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(8048), __webpack_require__.e(4801)]).then(() => (() => ((__webpack_require__(94801)))));
	},
	"./cWrapper": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(8454), __webpack_require__.e(8520), __webpack_require__.e(303)]).then(() => (() => ((__webpack_require__(60303)))));
	},
	"./Request": () => {
		return Promise.all([__webpack_require__.e(8173), __webpack_require__.e(1295), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(4853)]).then(() => (() => ((__webpack_require__(84853)))));
	},
	"./Link": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(5579), __webpack_require__.e(6161), __webpack_require__.e(3470)]).then(() => (() => ((__webpack_require__(63470)))));
	},
	"./Selectors": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(8454), __webpack_require__.e(5579), __webpack_require__.e(1140)]).then(() => (() => ((__webpack_require__(21140)))));
	},
	"./Analytics": () => {
		return Promise.all([__webpack_require__.e(4306), __webpack_require__.e(8849)]).then(() => (() => ((__webpack_require__(58849)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(5532), __webpack_require__.e(7359), __webpack_require__.e(8173), __webpack_require__.e(4582), __webpack_require__.e(8454), __webpack_require__.e(8060), __webpack_require__.e(5579), __webpack_require__.e(8520), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(5999), __webpack_require__.e(798)]).then(() => (() => ((__webpack_require__(10798)))));
	},
	"./ViewOnlyAlert": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(1236)]).then(() => (() => ((__webpack_require__(61236)))));
	},
	"./ViewOnlyTooltip": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(41), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(6295)]).then(() => (() => ((__webpack_require__(56295)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});